export const STATUS_PENDING = 'pending';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';

export const MYCRM_TO_MILLI_STATUS_TYPES = {
  1: STATUS_PENDING,
  2: STATUS_SUCCESS,
  99: STATUS_ERROR,
};
